import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/messagePage.css';

function Unauthorized() {
  return (
    <div className="error-message-container">
      <h3 className="error-message-title">Access denied</h3>
      <p className="error-message">
        You do not have permission to view this page. If you believe this is a mistake, contact
        your board or IT administrator.
      </p>
      <Link className="button" style={{ marginTop: '20px' }} to="/main">
        Go to main page
      </Link>
    </div>
  );
}

export default Unauthorized;
